import { usePage } from '@inertiajs/react'
import { FC } from 'react'
import { ClientPageProps } from 'types'
import { OrderCard } from './components/OrderCard/OrderCard'
import { Text } from '@blueprintjs/core'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

type TPageProps = {
  orders: Data.Order[]
} & ClientPageProps

const ProfileOrdersPageContent: FC<TProps> = () => {
  const {
    props: { orders },
  } = usePage<TPageProps>()

  const { t } = useTranslation(ClientLocaleNS.ProfilePage)

  return (
    <div className="flex flex-1 flex-col p-5 gap-5">
      <Text tagName="h3" className="font-body---24px">
        {t('payments.title')}
      </Text>
      <ul className="grid grid-cols-6 gap-3">
        {orders.map((order) => {
          return (
            <li key={order.id} className="flex">
              <OrderCard order={order}></OrderCard>
            </li>
          )
        })}
      </ul>
      <div></div>
    </div>
  )
}

export { ProfileOrdersPageContent }
